<template>
  <v-container
    id="operation-parameters"
    fluid
    tag="section"
  >
    <base-material-card
      inline
      icon="mdi-cog-outline"
      :title="`${$t('sidebar.parameters').toUpperCase()}`"
      class="px-5 py-3"
    >
      <v-col
        cols="12"
        sm="12"
      >
        <!-- Ajouter un paramètre (Seulement pour le rôle 'admin')-->
        <v-col
          v-if="isRoleAdmin"
          class="text-right ml-4"
          cols="12"
        >
          <v-btn
            color="success"
            @click="addItem"
          >
            {{ $t('Add') }}
            <v-icon
              right
              dark
            >
              mdi-plus-circle-outline
            </v-icon>
          </v-btn>
        </v-col>

        <v-data-table
          :headers="tableHeaders"
          :items="table"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          hide-default-footer
          :search="search"
          item-key="id"
          @page-count="pageCount = $event"
        >
          <!-- Search-->
          <template #top>
            <v-text-field
              v-model="search"
              :label="$t('search')"
              class="mx-4"
            />
          </template>

          <!-- Note-->
          <template
            slot="item.note"
            slot-scope="props"
          >
            <span>{{ `${props.item.note.slice(0, 50)}...` }}</span>
          </template>

          <!-- Système-->
          <template
            slot="item.systeme"
            slot-scope="props"
          >
            <v-icon
              v-if="props.item.systeme"
              color="primary"
            >
              mdi-check
            </v-icon>
          </template>

          <!-- Action-->
          <template
            slot="item.action"
            slot-scope="props"
          >
            <!-- Edit-->
            <v-btn
              fab
              dark
              x-small
              color="success"
              :title="$t('Edit')"
              @click="editItem(props.item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>

            <!--  Delete (Seulement pour le rôle 'admin')-->
            <v-btn
              v-if="isRoleAdmin"
              class="ml-2"
              fab
              dark
              x-small
              color="red"
              :title="$t('Delete')"
              @click="deleteItem(props.item.id)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination
            v-model="page"
            :length="pageCount"
          />
          <v-row
            justify="center"
            align="center"
          >
            <v-col
              cols="12"
              sm="4"
            >
              <!-- <v-text-field
                :value="itemsPerPage"
                :label="$t('table.Items_per_page')"
                type="number"
                min="-1"
                max="15"
                @input="itemsPerPage = parseInt($event, 10)"
              /> -->
              <v-select
                v-model="itemsPerPage"
                :items="itemsPage"
                :label="$t('table.Items_per_page')"
              />
            </v-col>
          </v-row>
        </div>
      </v-col>
    </base-material-card>

    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card v-if="submitForm">
        <validation-observer
          ref="obs"
          v-slot="{ handleSubmit }"
        >
          <form>
            <v-toolbar
              dark
              color="primary"
            >
              <v-btn
                icon
                dark
                @click="dialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>{{ submitType === 'edit' ? $t('Edit') : $t('Add') }} {{ $t('parameters.a_parameter') }}</v-toolbar-title>
              <v-spacer />
            </v-toolbar>

            <!-- Descrition-->
            <v-row
              align="center"
              dense
            >
              <v-col
                class="text-right body-1 grey--text mr-4"
                cols="2"
              >
                Description
              </v-col>

              <v-col cols="8">
                <validation-provider
                  v-slot="{ errors, valid }"
                  name="Description"
                  rules="required"
                >
                  <v-text-field
                    v-model="submitForm.description"
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </validation-provider>
              </v-col>
            </v-row>

            <!-- Valeur-->
            <v-row
              align="center"
              dense
            >
              <v-col
                class="text-right body-1 grey--text mr-4"
                cols="2"
              >
                {{ $t('Value') }}
              </v-col>

              <v-col cols="8">
                <v-text-field
                  v-model="submitForm.valeur"
                />
              </v-col>
            </v-row>

            <!-- Code-->
            <v-row
              align="center"
              dense
            >
              <v-col
                class="text-right body-1 grey--text mr-4"
                cols="2"
              >
                Code
              </v-col>

              <v-col cols="8">
                <v-text-field
                  v-model="submitForm.code"
                />
              </v-col>
            </v-row>

            <!-- Note-->
            <v-row
              align="center"
              dense
            >
              <v-col
                class="text-right body-1 grey--text mr-4"
                cols="2"
              >
                Note
              </v-col>

              <v-col cols="8">
                <validation-provider
                  v-slot="{ errors, valid }"
                  name="Note"
                  rules="required"
                >
                  <v-textarea
                    v-model="submitForm.note"
                    solo
                    append-icon="mdi-comment"
                    :error-messages="errors"
                    :success="valid"
                    required
                  />
                </validation-provider>
              </v-col>
            </v-row>

            <!--  Système-->
            <v-row
              v-if="isRoleAdmin"
              align="center"
              dense
            >
              <v-col
                class="text-right body-1 grey--text mr-4"
                cols="2"
              >
                {{ $t('System') }}
              </v-col>

              <v-col cols="8">
                <v-checkbox
                  v-model="submitForm.systeme"
                />
              </v-col>
            </v-row>

            <div class="pa-3 text-center">
              <!--  Bouton annuler-->
              <v-btn
                color="error"
                @click="dialog = false"
              >
                {{ $t('Cancel') }}
              </v-btn>
              <!--  Bouton submit-->
              <v-btn
                color="success"
                class="ml-3"
                @click="handleSubmit(submit)"
              >
                {{ $t('Validate') }}
              </v-btn>
            </div>
          </form>
        </validation-observer>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  // Services
  import ParametersService from '@/services/01Cell/ParametersService'
  // Mixins
  import { roles } from '@/mixins/roles'
  // Other
  import { mapState } from 'vuex'
  import {
    ValidationObserver,
    ValidationProvider,
  } from 'vee-validate'
  import Swal from 'sweetalert2'

  export default {
    name: 'OperationParameters',
    components: {
      ValidationProvider,
      ValidationObserver,
    },
    mixins: [roles],
    data () {
      return {
        search: '',
        submitForm: {},
        submitType: null,
        table: [],
        tableHeaders: [
          { text: this.$i18n.t('Number'), value: 'no', sortable: true, class: 'text-h4 primary--text' },
          { text: 'Description', value: 'description', sortable: true, class: 'text-h4 primary--text' },
          { text: this.$i18n.t('Value'), value: 'valeur', sortable: true, class: 'text-h4 primary--text' },
          { text: 'Code', value: 'code', sortable: true, class: 'text-h4 primary--text' },
          { text: 'Note', value: 'note', sortable: true, class: 'text-h4 primary--text' },
          { text: this.$i18n.t('System'), value: 'systeme', sortable: true, class: 'text-h4 primary--text' },
          { text: 'Action', value: 'action', sortable: false, align: 'end', class: 'text-h4 primary--text', width: 150 },
        ],
        page: 1,
        pageCount: 0,
        itemsPerPage: 50,
        itemsPage: [5, 10, 25, 50, 100],
        dialog: false,
      }
    },

    computed: {
      ...mapState(['userInfo']),
    },

    mounted () {
      // Si l'utilisateur n'est pas 'admin', on enlève le champs 'Système' dans la table
      if (!this.isRoleAdmin) this.tableHeaders.splice(4, 1)
      this.getParameter()
    },

    methods: {
      async getParameter () {
        // Start Spinner
        this.$loading.show()
        try {
          const table = await ParametersService.list()
          // Si c'est pas un utilisateur 'admin', l'utilisateur ne peut pas voir les paramètre dont la variable 'systeme' est true
          this.table = table.filter(item => {
            if (!this.isRoleAdmin) {
              if (!item.systeme) return item
            } else {
              return item
            }
          })

          // Stop Spinner
          this.$loading.hide()
        } catch (error) {
          console.log(error)
          // Stop Spinner
          this.$loading.hide()
        }
      },
      async editItem (item) {
        // Start Spinner
        this.$loading.show()
        try {
          // Edit
          this.submitType = 'edit'
          // Paramètre
          this.submitForm = await ParametersService.view(item.id)
          // Show dialog
          this.dialog = true
          // Stop Spinner
          this.$loading.hide()
        } catch (error) {
          console.log(error)
          // Stop Spinner
          this.$loading.hide()
        }
      },
      addItem () {
        // Ajout
        this.submitType = 'add'
        // Reset du submit
        this.submitForm = {}
        // Show dialog
        this.dialog = true
      },
      deleteItem (id) {
        // SweetAlert
        Swal.fire({
          icon: 'warning',
          title: this.$i18n.t('Are_you_sure'),
          text: `${this.$i18n.t('parameters.delete')} ?`,
          showCancelButton: true,
          confirmButtonColor: '#DD6B55',
          confirmButtonText: this.$i18n.t('Yes_delete_it'),
          cancelButtonText: this.$i18n.t('Cancel'),
        }).then(async (result) => {
          if (result.value) {
            // Start Loader
            this.$loading.show()
            try {
              await ParametersService.remove(id)
              // On va rechercher les paramètres
              this.getParameter()
            } catch (err) {
              // Stop Spinner
              this.$loading.hide()
            }
          }
        })
      },
      async submit () {
        // Hide dialog
        this.dialog = false

        // Start Spinner
        this.$loading.show()
        try {
          if (this.submitType === 'edit') {
            await ParametersService.update(this.submitForm, this.submitForm.id)
          } else {
            await ParametersService.save(this.submitForm)
          }
          // On va rechercher les paramètres
          this.getParameter()
        } catch (error) {
          console.log(error)
          // Stop Spinner
          this.$loading.hide()
        }
      },
    },
  }
</script>
